import React, { useContext, useEffect, useRef, useState } from 'react';
import axios from "axios";
import { Link, navigate } from 'raviger';
import Moment from 'react-moment';
import { Button, Card, Col, Form as BootstrapForm, ListGroup, Modal, OverlayTrigger, Row, Tooltip, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowAltCircleLeft,
  faEnvelope,
  faInfoCircle
} from '@fortawesome/free-solid-svg-icons';
import {
  faCircleE, faCircleI, faCircleO, faCircleV, faPencil, faUserUnlock
} from '@fortawesome/pro-solid-svg-icons';
import { Field, Formik } from "formik";
import Switch from '@mui/material/Switch';
import * as Yup from 'yup';
import Header from '../components/Header';
import { TextInput } from '../components/Form';
import { SystemErrorContext } from '../components/SystemError';
import LoadingLink from '../components/LoadingLink';
import { AuthContext } from "../accounts/AccountsReducer";
import ActionsDropdown from '../components/ActionsDropdown';

function UserProfile({ id, incident, organization }) {

  const { dispatch, state } = useContext(AuthContext);
  const { setShowSystemError } = useContext(SystemErrorContext);
  const [isLoading, setIsLoading] = useState(false);

  const path = window.location.pathname;

  const phoneRegex = /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,3}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/;

  const [showUserResetConfirm, setShowUserResetConfirm] = useState(false);
  const handleUserResetClose = () => setShowUserResetConfirm(false);
  const [showChangeEmail, setShowChangeEmail] = useState(false);
  const handleChangeEmailClose = () => setShowChangeEmail(false);

  const newEmailRef = useRef(null);

  const [newEmailData, setNewEmailData] = useState({id:id, new_email:'', org_slug:organization});
  const [showEditModal, setShowEditModal] = useState(false);
  const handleCloseEditModal = () => {setShowEditModal(false);};

  // Initial user data.
  const [data, setData] = useState({
    id: id,
    incident: state.incident.id,
    organization: state.organization.id,
    org_names: state.user.org_names.join(", ") || '',
    first_name: state.user.first_name || '',
    last_name: state.user.last_name || '',
    cell_phone: state.user.display_phone || '',
    display_phone: state.user.display_phone || '',
    email: state.user.email || '',
    incident_perms: state.user.incident_perms || false,
    user_perms: state.user.user_perms || false,
    vet_perms: state.user.vet_perms || false,
    vet_role: '',
    subscribed_hotline:state.user.subscribed_hotline || false,
    subscribed_dispatch:state.user.subscribed_dispatch || false,
  });

  const handleResetUserSubmit = async () => {
    await axios.patch('/accounts/api/user/' + id + '/', {'reset_password':true, 'organization': state.organization.id})
    .then(response => {
      handleUserResetClose();
    })
    .catch(error => {
      setShowSystemError(true);
    });
  }

  const hotlineSubscribe = () => {
    const subscribed_hotline = !data.subscribed_hotline;
    setData(prevState => ({ ...prevState, subscribed_hotline }));
    dispatch({type: 'USER_LOADED', user: { ...state.user, subscribed_hotline }});
    axios.patch('/incident/api/incident/' + state.incident.id + '/subscribe/', {'hotline_subscribe':subscribed_hotline})
    .catch(error => {
      setData(prevState => ({ ...prevState, subscribed_hotline: !subscribed_hotline }));
      dispatch({type: 'USER_LOADED', user: { ...state.user, subscribed_hotline: !subscribed_hotline }});
      setShowSystemError(true);
    });
  }

  const dispatchSubscribe = () => {
    const subscribed_dispatch = !data.subscribed_dispatch;
    setData(prevState => ({ ...prevState, subscribed_dispatch }));
    dispatch({type: 'USER_LOADED', user: { ...state.user, subscribed_dispatch }});
    axios.patch('/incident/api/incident/' + state.incident.id + '/subscribe/', {'dispatch_subscribe':subscribed_dispatch})
    .catch(error => {
      setData(prevState => ({ ...prevState, subscribed_dispatch: !subscribed_dispatch }));
      dispatch({type: 'USER_LOADED', user: { ...state.user, subscribed_dispatch: !subscribed_dispatch }});
      setShowSystemError(true);
    });
  }

  return (
    <>
    <Header><span id="back" style={{cursor:'pointer'}} onClick={() => state.prevLocation ? navigate(state.prevLocation) : navigate('/' + organization + '/' + incident)} className="me-3"><FontAwesomeIcon icon={faArrowAltCircleLeft} size="lg" inverse /></span>User Profile</Header>
    <div className="row">
      <div className="col-10 d-flex" style={{marginRight:"-15px"}}>
        <Card className="border rounded d-flex" style={{width:"100%"}}>
          <Card.Body style={{marginTop:"-10px", marginBottom:"-6px"}}>
            <div className="d-flex justify-content-between">
              <h4 className="h5 pt-2" style={{marginBottom:"10px"}}>Information
              </h4>
              {isLoading ? (
                <Spinner
                  className="align-self-center me-3"
                  {...{
                    as: 'span',
                    animation: 'border',
                    size: undefined,
                    role: 'status',
                    'aria-hidden': 'true',
                    variant: 'light',
                    style: {
                      height: '1.5rem',
                      width: '1.5rem',
                      marginBottom: '0.75rem'
                    }
                  }}
                />
              ) : (
                <ActionsDropdown variant="secondary" title="Actions">
                    <LoadingLink
                        isLoading={false}
                        className="d-block"
                        onClick={() => {setShowEditModal(true);}}
                        label="Update User Profile"
                    >
                        <FontAwesomeIcon icon={faPencil} className="fas" inverse />
                        
                    </LoadingLink>
                    <LoadingLink
                        isLoading={false}
                        className="d-block"
                        onClick={() => {setShowUserResetConfirm(true);}}
                        label="Change Password"
                    >
                        <FontAwesomeIcon icon={faUserUnlock} className="fas" inverse />
                    </LoadingLink>
                    <LoadingLink
                        isLoading={false}
                        className="d-block"
                        onClick={() => {setShowChangeEmail(true);setTimeout(()=>{newEmailRef.current && newEmailRef.current.focus()}, 1);}}
                        label="Change Email"
                    >
                        <FontAwesomeIcon icon={faEnvelope} className="fas" inverse />
                    </LoadingLink>
                </ActionsDropdown>
              )}
            </div>
            <p className="phr pt-0 mt-1" />
            <ListGroup variant="flush" style={{marginTop:"-13px", marginBottom:"-13px"}}>
              <ListGroup.Item>
                <div className="row">
                  <span className="col-6"><b>First Name:</b> {data.first_name}</span>
                  <span className="col-6"><b>Last Name:</b> {data.last_name}</span>
                </div>
              </ListGroup.Item>
              <ListGroup.Item>
                <div className="row">
                  <span className="col-6"><b>Phone:</b> {data.display_phone}</span>
                </div>
              </ListGroup.Item>
              <ListGroup.Item>
                <div className="row">
                  <span className="col-6"><b>Email:</b> {data.email}</span>
                </div>
              </ListGroup.Item>
              <ListGroup.Item>
                <div className="row">
                  <span className="col-6"><b>Permissions: </b>
                    {data.user_perms ? <OverlayTrigger
                        key={"org-perms"}
                        placement="top"
                        overlay={
                            <Tooltip id={`tooltip-org-perms`}>
                            User is an Organization Admin
                            </Tooltip>
                        }
                        >
                        <FontAwesomeIcon icon={faCircleO} size="lg" className="ms-1" />
                        </OverlayTrigger> : ""}
                        {data.incident_perms ? <OverlayTrigger
                        key={"incident-perms"}
                        placement="top"
                        overlay={
                            <Tooltip id={`tooltip-incident-perms`}>
                            User is an Incident Admin
                            </Tooltip>
                        }
                        >
                        <FontAwesomeIcon icon={faCircleI} size="lg" className="ms-1" />
                        </OverlayTrigger> : ""}
                        {data.vet_perms ? <OverlayTrigger
                        key={"vet-perms"}
                        placement="top"
                        overlay={
                            <Tooltip id={`tooltip-vet-perms`}>
                            User has veterinary permissions{data.vet_role === 'Veterinarian' ? ' and has the Veterinarian role.' : data.vet_role === 'Vet Tech' ? ' and has the Vet Tech role.' : ''}
                            </Tooltip>
                        }
                        >
                        <FontAwesomeIcon icon={faCircleV} size="lg" className="ms-1" />
                    </OverlayTrigger> : ""}
                    {!data.user_perms && !data.incident_perms && !data.vet_perms ? "None" : ""}
                  </span>
                </div>
              </ListGroup.Item>
              <ListGroup.Item>
                <span><b>Organizations: </b> {data.org_names || "None"}</span>
              </ListGroup.Item>
              <ListGroup.Item className="pt-1 pb-1">
                <span><b>Subscribe to Hotline Notifications
                  <OverlayTrigger
                    key={"hotline-subscribe"}
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-hotline-subscribe`}>
                        Subscribe to receive email notifications when Service Requests are created for this incident.
                      </Tooltip>
                    }
                  >
                    <FontAwesomeIcon icon={faInfoCircle} size="sm" className="fa-move-up ms-1" />
                  </OverlayTrigger>: </b> <span style={{marginTop:"-3px", marginBottom:"-5px", display:"inline-block"}}><Switch id="hotline_notifications" name="hotline_notifications" color="primary" checked={data.subscribed_hotline} onChange={() => {hotlineSubscribe()}} /></span></span>
              </ListGroup.Item>
              <ListGroup.Item className="pt-1 pb-1" style={{marginBottom:"3px"}}>
                <span><b>Subscribe to Field Notifications<OverlayTrigger
                    key={"dispatch-subscribe"}
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-dispatch-subscribe`}>
                        Subscribe to receive email notifications when Field Assignments are created for this incident.
                      </Tooltip>
                    }
                  >
                    <FontAwesomeIcon icon={faInfoCircle} className="fa-move-up ms-1" />
                  </OverlayTrigger>: </b> <span style={{marginTop:"-3px", marginBottom:"-8px", display:"inline-block"}}><Switch id="dispatch_notifications" name="dispatch_notifications" color="primary" checked={data.subscribed_dispatch} onChange={() => {dispatchSubscribe()}} /></span></span>
              </ListGroup.Item>
              {/* <ListGroup.Item>
                <div className="row">
                  <span className="col-6"><b>{state.organization.name} Access Expires:</b> {state.user.access_expires_at ? <Moment format="LL">{state.user.access_expires_at}</Moment> : "Never"}</span>
                </div>
              </ListGroup.Item> */}
            </ListGroup>
          </Card.Body>
        </Card>
      </div>
    </div>
    <Modal show={showUserResetConfirm} onHide={handleUserResetClose}>
      <Modal.Header closeButton>
        <Modal.Title>Change Password</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p style={{marginBottom:"5px"}}>
          Changing your password will require email confirmation. Are you sure you would like to initialize a password reset?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleResetUserSubmit}>Send Password Reset Email</Button>
        <Button variant="secondary" onClick={handleUserResetClose}>Cancel</Button>
      </Modal.Footer>
    </Modal>
    <Formik
      initialValues={newEmailData}
      enableReinitialize={true}
      validationSchema={Yup.object({
        id: Yup.string().required(),
        new_email: Yup.string().required('Please enter a valid email address.')
          .max(50, 'Must be 50 characters or less')
          .email('Please enter a valid email address.'),
      })}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        // Send verification email.
        axios.get('/accounts/api/user/' + id + '/email_verification/', {params:values})
        .then(response => {
          resetForm();
          setNewEmailData({id:id, new_email:'', org_slug:organization});
          setShowChangeEmail(false);
        })
        .catch(error => {
          setShowSystemError(true);
        });
      }}
    >
    {formikProps => (
      <Modal show={showChangeEmail} onHide={handleChangeEmailClose} aria-modal="true">
        <Modal.Header closeButton>
          <Modal.Title>Change Email Address</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Changing your email address will require your verification before Shelterly uses your new email address.</p>
          <Row className="mt-3">
            <TextInput
              label="New Email Address"
              name="new_email"
              id="new_email"
              xs="12"
              ref={newEmailRef}
            />
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => {formikProps.submitForm();}}>Send Verification Email</Button>
          <Button variant="secondary" onClick={handleChangeEmailClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    )}
    </Formik>
    <Formik
      initialValues={data}
      enableReinitialize={true}
      validationSchema={Yup.object({
        first_name: Yup.string()
          .max(50, 'Must be 50 characters or less')
          .required('Required'),
        last_name: Yup.string()
          .max(50, 'Must be 50 characters or less')
          .required('Required'),
        // email: Yup.string()
        //   .max(50, 'Must be 50 characters or less')
        //   .required('Required'),
        cell_phone: Yup.string().required('Required').matches(phoneRegex, "Phone number is not valid").min(10, "Phone number is not valid"),
      })}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        axios.patch('/accounts/api/user/' + data.id + '/', values)
        .then(response => {
          setData(prevState => ({ ...prevState, "first_name":response.data.first_name, "last_name":response.data.last_name, "cell_phone":response.data.display_phone, "display_phone":response.data.display_phone}))
          dispatch({type: 'USER_LOADED', user: response.data });
          setShowEditModal(false);
        })
        .catch(error => {
          setShowSystemError(true);
        });
      }}
    >
    {formikProps => (
    <Modal show={showEditModal} onHide={handleCloseEditModal} aria-modal="true">
      <Modal.Header closeButton>
        <Modal.Title>Update User Profile</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="gx-2">
          <TextInput
            type="text"
            label="First Name*"
            name="first_name"
            id="first_name"
            xs="6"
          />
          <TextInput
            type="text"
            label="Last Name*"
            name="last_name"
            id="last_name"
            xs="6"
          />
        </Row>
        <Row className="mt-3 gx-2">
          <TextInput
            type="text"
            label="Phone*"
            name="cell_phone"
            id="cell_phone"
            xs="6"
            value={formikProps.values.cell_phone || ''}
          />
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => {formikProps.submitForm();}}>Save</Button>
        <Button variant="secondary" onClick={handleCloseEditModal}>Close</Button>
      </Modal.Footer>
    </Modal>
    )}
    </Formik>
    </>
  );
};

export default UserProfile;
